"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeProfile = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../theme/colors");
var button_1 = require("../button");
var employee_thumbnail_1 = require("../employee-thumbnail");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var mini_icons_1 = require("../mini-icons");
var padding_1 = require("../padding");
var small_caps_1 = require("../small-caps");
var stack_1 = require("../stack");
var text_1 = require("../text");
var text_link_1 = require("../text-link");
function copyEmail(email, onCopyEmail) {
    if (email) {
        navigator.clipboard.writeText(email);
        if (onCopyEmail) {
            onCopyEmail();
        }
    }
}
function EmployeeProfile(props) {
    var departments = props.departments, imageUrl = props.imageUrl, name = props.name, title = props.title, email = props.email, variant = props.variant, onCopyEmail = props.onCopyEmail;
    if (variant === 'inline') {
        return (react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
            imageUrl ? (react_1.default.createElement(employee_thumbnail_1.EmployeeThumbnail, { sizeInPixels: 40, imageUrl: imageUrl, variant: "round" })) : (react_1.default.createElement(StyledFallback, { variant: "round", size: 40 },
                react_1.default.createElement(mini_icons_1.MiniIconPerson, { color: colors_1.colors.steel[200] }))),
            react_1.default.createElement(padding_1.Padding, { left: 8 },
                react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[500], size: "large" }, name),
                react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[400] },
                    " ",
                    title),
                departments && react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[400] }, departments[0]))));
    }
    if (variant === 'small') {
        return (react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
            imageUrl ? (react_1.default.createElement(employee_thumbnail_1.EmployeeThumbnail, { sizeInPixels: 40, imageUrl: imageUrl, variant: "round" })) : (react_1.default.createElement(StyledFallback, { variant: "round" },
                react_1.default.createElement(mini_icons_1.MiniIconPerson, { color: colors_1.colors.steel[200] }))),
            react_1.default.createElement(padding_1.Padding, { left: 12 },
                react_1.default.createElement(stack_1.Stack, { direction: "vertical", gap: 0 },
                    title && react_1.default.createElement(small_caps_1.SmallCaps, null, title),
                    react_1.default.createElement(text_1.Text, { color: "dark" }, name)))));
    }
    if (variant === 'details' || variant === 'expanded') {
        return (react_1.default.createElement(flexbox_1.Flexbox, null,
            react_1.default.createElement(padding_1.Padding, { right: 12, top: 8 }, imageUrl ? (react_1.default.createElement(employee_thumbnail_1.EmployeeThumbnail, { sizeInPixels: 40, imageUrl: imageUrl, variant: "round" })) : (react_1.default.createElement(StyledFallback, { variant: "round" },
                react_1.default.createElement(mini_icons_1.MiniIconPerson, { color: colors_1.colors.steel[200] })))),
            react_1.default.createElement(flexbox_1.Flexbox, { flexDirection: "column", justifyContent: "center", gap: 8 },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[500], size: "large" }, name),
                    react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[400] }, title),
                    departments && react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[400] }, departments[0])),
                email && (react_1.default.createElement(stack_1.Stack, { direction: "horizontal", gap: 16 },
                    react_1.default.createElement(button_1.Button, { size: "secondary", onClick: function () { return copyEmail(email, onCopyEmail); } },
                        react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center", flexDirection: "row" },
                            react_1.default.createElement(icons_1.IconEmailOutline, { size: 18 }),
                            react_1.default.createElement(padding_1.Padding, { left: 8 },
                                react_1.default.createElement(text_1.Text, null, "Copy email address")))))))));
    }
    return (react_1.default.createElement(flexbox_1.Flexbox, null,
        react_1.default.createElement(padding_1.Padding, { right: 20 }, imageUrl ? (react_1.default.createElement(employee_thumbnail_1.EmployeeThumbnail, { imageUrl: imageUrl, sizeInPixels: 60 })) : (react_1.default.createElement(StyledFallback, { variant: "round", size: 60 },
            react_1.default.createElement(mini_icons_1.MiniIconPerson, { color: colors_1.colors.steel[200] })))),
        react_1.default.createElement(flexbox_1.Flexbox, { flexDirection: "column", justifyContent: "center" },
            react_1.default.createElement(text_1.Text, { size: "regular", color: "dark" },
                react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[500] }, name),
                react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[400] }, title),
                email && (react_1.default.createElement(text_link_1.TextLink, { style: { color: colors_1.colors.steel[500] }, href: "mailto:".concat(email) }, email))))));
}
exports.EmployeeProfile = EmployeeProfile;
var StyledFallback = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n"])), function (_a) {
    var size = _a.size;
    return (size ? "".concat(size, "px") : '40px');
}, function (_a) {
    var size = _a.size;
    return (size ? "".concat(size, "px") : '40px');
}, colors_1.colors.steel[100], function (_a) {
    var variant = _a.variant;
    return (variant === 'squircle' ? "clip-path: polygon(".concat((0, employee_thumbnail_1.squircleClipPath)(6), ");") : 'border-radius: 50%;');
});
var templateObject_1;
//# sourceMappingURL=index.js.map